'use client'

import { useTranslations, useLocale } from 'next-intl'
import Link from 'next/link'
import Image from 'next/image'

export default function Footer() {
  const t = useTranslations('footer')
  const nav = useTranslations('navigation')
  const locale = useLocale()

  return (
    <footer className="bg-secondary-900 text-white py-8 sm:py-12">
      <div className="container">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 mb-8">
          {/* Logo and Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-3 sm:mb-4">
              <div className="relative h-10 w-10 sm:h-12 sm:w-12 md:h-14 md:w-14">
                <Image
                  src="/tobg-logo.png"
                  alt="TOBG Logo"
                  fill
                  className="object-contain rounded-lg"
                />
              </div>
              <h3 className="text-lg sm:text-xl font-bold">TOBG</h3>
            </div>
            <p className="text-sm sm:text-base text-secondary-400">
              AI Development. AI Automation. AI Privacy.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-semibold mb-3 sm:mb-4 text-base sm:text-lg">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <Link href={`/${locale}`} className="text-secondary-400 hover:text-white transition-colors">
                  {nav('home')}
                </Link>
              </li>
              <li>
                <Link href={`/${locale}/about`} className="text-secondary-400 hover:text-white transition-colors">
                  {nav('about')}
                </Link>
              </li>
              <li>
                <Link href={`/${locale}/services`} className="text-secondary-400 hover:text-white transition-colors">
                  {nav('services')}
                </Link>
              </li>
              <li>
                <Link href={`/${locale}/blog`} className="text-secondary-400 hover:text-white transition-colors">
                  {nav('blog')}
                </Link>
              </li>
              <li>
                <Link href={`/${locale}/contact`} className="text-secondary-400 hover:text-white transition-colors">
                  {nav('contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-semibold mb-3 sm:mb-4 text-base sm:text-lg">{t('productsColumn')}</h4>
            <ul className="space-y-2">
              <li>
                <Link href={`/${locale}/products/aipuna`} className="text-secondary-400 hover:text-white transition-colors">
                  AIPuna
                </Link>
              </li>
              <li>
                <Link href={`/${locale}/products/janus`} className="text-secondary-400 hover:text-white transition-colors">
                  Janus
                </Link>
              </li>
              <li>
                <Link href={`/${locale}/products/octochat`} className="text-secondary-400 hover:text-white transition-colors">
                  OctoChat
                </Link>
              </li>
              <li>
                <Link href={`/${locale}/products/learncoach`} className="text-secondary-400 hover:text-white transition-colors">
                  valid LearnCoach
                </Link>
              </li>
              <li>
                <Link href={`/${locale}/products/agodoc`} className="text-secondary-400 hover:text-white transition-colors">
                  agodoc
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold mb-3 sm:mb-4 text-base sm:text-lg">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link href={`/${locale}/info/datenschutz`} className="text-secondary-400 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link href={`/${locale}/info/datenschutz#terms`} className="text-secondary-400 hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link href={`/${locale}/info/datenschutz#cookies`} className="text-secondary-400 hover:text-white transition-colors">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link href={`/${locale}/info/datenschutz`} className="text-secondary-400 hover:text-white transition-colors">
                  DSGVO/GDPR
                </Link>
              </li>
              <li>
                <Link href={`/${locale}/info/impressum`} className="text-secondary-400 hover:text-white transition-colors">
                  Impressum
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-secondary-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-secondary-400 text-sm mb-4 md:mb-0">
            {t('copyright')}
          </p>
          <div className="flex space-x-4">
            <Link href={`/${locale}/contact`} className="text-secondary-400 hover:text-white transition-colors text-sm">
              {nav('contact')}
            </Link>
            <Link href={`/${locale}/info/impressum`} className="text-secondary-400 hover:text-white transition-colors text-sm">
              {nav('imprint')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
